export * from './types';
// Utils
import colors from './colors';
import getCurrencySymbols from './getCurrencySymbols';
import platformName, { PlatformType } from './platformName';

export {
  colors,
  // Utils
  getCurrencySymbols,
  platformName,
  PlatformType,
};
